module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik02NDAgNDgwSDBWMGg2NDB6Ii8+CiAgICA8cGF0aCBmaWxsPSIjZGYwMDAwIiBkPSJNNjQwIDQ4MEgwVjMxOS45OTdoNjQwem0wLTMxOS44NzVIMFYuMTIyaDY0MHoiLz4KICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/at.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/at.svg
// module chunks = 0